module.exports = __webpack_public_path__ + "static/media/sound_boleto.4eb99e2d.wav";